export default __webpack_public_path__ + "static/media/icon-info.7104f15a.svg";